<template>
    <div class="card" id="print-auc-info">
        <header class="card-header">
            <p class="card-header-title">Auction Info:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
                  <span class="icon">
                    <i class="fas fa-gavel"></i>
                  </span>
            </a>
        </header>
        <div class="">
            <div class="content">
                <table class="table">
                    <tbody>
                    <tr>
                        <th>Lot#:</th>
                        <td>{{ car.bid }}</td>
                    </tr>
                    <tr>
                        <th>Date & time:</th>
                        <td>{{ car.lot_date }}</td>
                    </tr>
                    <tr>
                        <th>Auction:</th>
                        <td>{{ car.auction_name }}</td>
                    </tr>
                    <tr>
                        <th>Score:</th>
                        <td><strong class="has-text-danger">{{ car.scores_en }}</strong></td>
                    </tr>
                    <tr v-if="columnRemoved('result_price')">
                        <th>Result price:</th>
                        <td>
                            <strong v-if="!checkIfColumnIsHidden('result_price')">{{ car.result_price * 1000 | formatNumber }}</strong>
                            <button v-if="isAdmin && !checkIfColumnIsHidden('result_price')"
                                    @click="hideCarResultPrice('result_price')"
                                    class="button is-outlined is-small is-danger tooltip"
                                    :class="{ 'is-loading' : isLoading }"
                                    data-tooltip="Hide result price for this car.">
                                <span class="icon ">
                                    <i class="fas fa-eye"></i>
                                </span>
                            </button>
                            <button v-if="isAdmin && checkIfColumnIsHidden('result_price')"
                                    @click="showCarResultPrice('result_price')"
                                    class="button is-outlined is-small is-danger tooltip"
                                    :class="{ 'is-loading' : isLoading }"
                                    data-tooltip="Show result price for this car.">
                                <span class="icon ">
                                     <i class="fas fa-eye-slash"></i>
                                </span>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props:['car'],
        methods: {
            columnRemoved(column) {
                return this.$store.getters.checkIfCurrentUserCarColumnIsHidden(column)
            },
            hideCarResultPrice(column) {
                this.$store.dispatch('setCarHiddenFieldData', { car_id: this.car.id, name: column} )
                this.$store.dispatch('createCarHiddenField')
            },
            showCarResultPrice(column) {

                let fieldId = null;

                this.car.car_hidden_fields.map(object => {
                    if (object.name === column) {
                        fieldId = object.id
                    }
                })

                this.$store.dispatch('deleteUserCarHiddenField', { carId: this.car.id, fieldId: fieldId})
            },
            checkIfColumnIsHidden(column) {
                let isHidden = false

                this.car.car_hidden_fields.map(object => {
                    if (object.name === column) {
                        isHidden = true
                    }
                })

                return isHidden
            },
        },
        computed: {
            isLoading() {
                return this.$store.getters.getLoaderStatus
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    .button {
        float: right;
    }
    table {
        font-size: small;
    }
</style>




// WEBPACK FOOTER //
// src/components/Cars/Car/Details/AucInfo.vue